// This file was generated. All changes will be lost.
// Your changes will be lost.

export class ApiSettings {

	public static ApiUrl : string = "https://api-hubstaging.endeavorco.com/";
	public static AzureAudience : string = "https://imgworld.onmicrosoft.com/5ce32448-834e-4a78-93a5-417bb0d11ed9";
	public static AzureAuthority : string = "https://login.microsoftonline.com/imgworld.onmicrosoft.com";
	public static AzureClientId : string = "442e95f9-8b4b-450b-9146-7487abea503c";
	public static Environment: string = "Staging";
}
